import responseTag from './Response/index';

const tags = {
  response: responseTag
};

export default tags;
